import { BootstrapTable } from 'react-bootstrap-table';

class CustomBootstrapTable extends BootstrapTable {
    updateLinkStyles() {
        // Where the pagination link looks like >, >>, <, << we want to add a class
        // of "borderless".
        const pageLinks = document.querySelectorAll('.page-link');

        _.each(pageLinks, link => {
            if (/\&/.test(link.innerHTML)) {
                link.classList.add('borderless');
            }
        });
    }

    componentDidMount() {
        this.updateLinkStyles();
    }
    componentDidUpdate() {
        this.updateLinkStyles();
    }
}

export default CustomBootstrapTable;
